import React from "react"

export const AmazonConnect = () => (
    <svg viewBox="0 0 256 235" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M246.7735,71.523 C240.8505,57.487 232.3675,44.902 221.5635,34.119 C199.5105,12.11 170.1585,0 138.8815,0 L138.6405,0 C117.7525,0.041 96.7735,6.078 77.9725,17.457 C60.2255,28.198 45.4255,43.298 36.3005,59.977 C35.5265,61.392 36.0465,63.167 37.4615,63.941 C38.8775,64.715 40.6505,64.195 41.4245,62.78 C50.0625,46.991 64.1165,32.669 80.9965,22.453 C98.8895,11.624 118.8265,5.879 138.6525,5.84 L138.8805,5.84 C168.5985,5.84 196.4885,17.346 217.4385,38.253 C238.5395,59.312 250.1595,87.404 250.1595,117.354 C250.1595,147.14 238.5605,175.143 217.4985,196.205 C196.4365,217.267 168.4335,228.867 138.6465,228.867 C118.8945,228.867 99.4885,223.635 82.5275,213.738 C66.0635,204.131 52.2375,190.375 42.5465,173.958 C41.7265,172.568 39.9355,172.108 38.5465,172.927 C37.1585,173.747 36.6975,175.538 37.5175,176.926 C47.7135,194.2 62.2605,208.674 79.5845,218.783 C97.4375,229.2 117.8605,234.707 138.6465,234.707 C169.9925,234.707 199.4625,222.5 221.6275,200.335 C243.7935,178.169 256.0005,148.7 256.0005,117.354 C256.0005,101.449 252.8965,86.03 246.7735,71.523 M13.6275,84.1368 L50.4945,84.1368 C52.1065,84.1368 53.4145,82.8288 53.4145,81.2168 C53.4145,79.6038 52.1065,78.2968 50.4945,78.2968 L13.6275,78.2968 C12.0145,78.2968 10.7075,79.6038 10.7075,81.2168 C10.7075,82.8288 12.0145,84.1368 13.6275,84.1368 M37.962,119.0567 C37.962,117.4437 36.655,116.1367 35.042,116.1367 L2.92,116.1367 C1.307,116.1367 5.68434189e-14,117.4437 5.68434189e-14,119.0567 C5.68434189e-14,120.6697 1.307,121.9767 2.92,121.9767 L35.042,121.9767 C36.655,121.9767 37.962,120.6697 37.962,119.0567 M50.3727,156.897 C50.3727,155.284 49.0657,153.977 47.4527,153.977 L8.0307,153.977 C6.4177,153.977 5.1107,155.284 5.1107,156.897 C5.1107,158.509 6.4177,159.817 8.0307,159.817 L47.4527,159.817 C49.0657,159.817 50.3727,158.509 50.3727,156.897 M76.3937,95.6573 C77.1597,95.5323 77.8437,95.1083 78.2957,94.4783 C78.7487,93.8483 78.9317,93.0643 78.8047,92.2993 C76.6437,79.2313 78.8317,67.6083 85.1347,58.6843 C90.6757,50.8393 99.2737,45.2853 109.3457,43.0473 C129.2277,38.6293 153.1327,47.6243 160.3517,73.3663 C160.5827,74.1903 161.1637,74.8713 161.9407,75.2293 C162.7177,75.5883 163.6127,75.5873 164.3887,75.2283 C172.4567,71.4993 180.6747,71.2353 187.5327,74.4863 C194.5207,77.7993 199.5977,84.3803 201.8267,93.0183 C202.1117,94.1223 203.0127,94.9593 204.1337,95.1623 C223.1647,98.6063 231.1727,113.1523 230.6667,126.0393 C230.3977,132.8963 227.7787,139.3793 223.2927,144.2923 C218.3107,149.7503 211.2267,153.0963 202.8017,153.9763 L170.6767,153.9763 C169.9387,153.9763 169.2277,154.2563 168.6867,154.7603 L119.7267,200.3473 L119.7267,156.5323 C119.7267,154.9193 118.4187,153.6123 116.8067,153.6123 L77.5227,153.6123 C69.6767,153.0183 62.9697,149.8123 58.1227,144.3363 C53.6957,139.3323 51.0847,132.7273 50.7737,125.7363 C50.4627,118.7583 52.5007,112.0293 56.5117,106.7903 C61.0287,100.8903 67.9037,97.0413 76.3937,95.6573 M44.9387,125.9963 C45.6087,141.0263 55.9917,157.9043 77.2037,159.4443 C77.2737,159.4493 77.3437,159.4523 77.4147,159.4523 L113.8857,159.4523 L113.8857,207.0563 C113.8857,208.2193 114.5757,209.2703 115.6407,209.7343 C116.0157,209.8973 116.4127,209.9773 116.8057,209.9773 C117.5307,209.9773 118.2447,209.7073 118.7957,209.1943 L171.8257,159.8173 L202.9507,159.8173 C203.0487,159.8173 203.1467,159.8123 203.2447,159.8023 C225.3967,157.5673 235.9107,141.3493 236.5027,126.2683 C236.8307,117.8973 234.2167,109.7073 229.1407,103.2053 C223.8577,96.4393 216.2237,91.8213 206.9797,89.7783 C204.0827,80.3033 198.1167,73.0403 190.0337,69.2083 C182.4727,65.6253 173.6887,65.4513 164.9987,68.6563 C160.9047,56.7533 153.1917,47.5293 142.5447,41.8593 C132.1437,36.3213 119.9037,34.7183 108.0787,37.3463 C96.5867,39.9003 86.7437,46.2823 80.3647,55.3153 C73.6227,64.8603 70.9727,76.9573 72.6367,90.4413 C52.6407,94.9793 44.2837,111.2863 44.9387,125.9963 M93.1246,110.542 C97.7536,110.542 101.5206,114.308 101.5206,118.937 C101.5206,123.566 97.7536,127.333 93.1246,127.333 C88.4956,127.333 84.7286,123.566 84.7286,118.937 C84.7286,114.308 88.4956,110.542 93.1246,110.542 M127.1686,85.465 C131.7976,85.465 135.5636,89.231 135.5636,93.86 C135.5636,98.49 131.7976,102.256 127.1686,102.256 C122.5396,102.256 118.7726,98.49 118.7726,93.86 C118.7726,89.231 122.5396,85.465 127.1686,85.465 M155.5226,134.034 C155.5226,138.664 151.7566,142.43 147.1266,142.43 C142.4976,142.43 138.7316,138.664 138.7316,134.034 C138.7316,129.405 142.4976,125.639 147.1266,125.639 C151.7566,125.639 155.5226,129.405 155.5226,134.034 M179.3466,99.833 C183.9756,99.833 187.7416,103.599 187.7416,108.228 C187.7416,112.857 183.9756,116.623 179.3466,116.623 C174.7166,116.623 170.9506,112.857 170.9506,108.228 C170.9506,103.599 174.7166,99.833 179.3466,99.833 M93.1246,133.173 C100.9746,133.173 107.3606,126.787 107.3606,118.937 C107.3606,116.937 106.9436,115.032 106.1956,113.303 L117.4256,104.226 C119.9746,106.623 123.4016,108.096 127.1686,108.096 C127.9336,108.096 128.6836,108.034 129.4166,107.917 L137.0596,123.98 C134.4856,126.557 132.8916,130.113 132.8916,134.034 C132.8916,141.884 139.2776,148.27 147.1266,148.27 C154.9766,148.27 161.3626,141.884 161.3626,134.034 C161.3626,131.646 160.7686,129.394 159.7246,127.415 L170.2926,119.206 C172.7546,121.24 175.9106,122.463 179.3466,122.463 C187.1956,122.463 193.5816,116.078 193.5816,108.228 C193.5816,100.378 187.1956,93.992 179.3466,93.992 C171.4966,93.992 165.1106,100.378 165.1106,108.228 C165.1106,110.536 165.6656,112.715 166.6446,114.645 L155.9986,122.913 C153.5636,120.967 150.4796,119.799 147.1266,119.799 C145.3176,119.799 143.5876,120.142 141.9946,120.76 L134.8836,105.815 C138.8036,103.276 141.4036,98.868 141.4036,93.86 C141.4036,86.011 135.0186,79.625 127.1686,79.625 C119.3186,79.625 112.9326,86.011 112.9326,93.86 C112.9326,95.836 113.3376,97.719 114.0686,99.43 L102.8166,108.524 C100.2736,106.155 96.8666,104.702 93.1246,104.702 C85.2746,104.702 78.8886,111.087 78.8886,118.937 C78.8886,126.787 85.2746,133.173 93.1246,133.173"></path>
        </g>
    </svg>
)

export const PureCloudIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 45" fill="#FF4F1F">
        <path d="M20.3,2.3c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0c-0.9,0-1.7-0.8-1.7-1.7   c0-0.5,0.2-1,0.5-1.3C19.3,2.5,19.8,2.3,20.3,2.3 M20.3,0c-2.3,0-4.2,2-4.1,4.3c0.1,2.1,1.8,3.8,3.9,3.9c0.1,0,0.1,0,0.2,0   c2.3,0,4.1-1.9,4.1-4.1S22.5,0,20.3,0L20.3,0z"></path>
        <path d="M17.5,28.9c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2H13c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2H17.5 M17.5,26.1  H13c-3.8,0-6.9,3.1-6.9,6.9c0,3.8,3.1,6.9,6.9,6.9h4.5c3.8,0,6.9-3.1,6.9-6.9C24.4,29.2,21.3,26.1,17.5,26.1L17.5,26.1z"></path>
        <path d="M17.5,12.7c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2H6.9c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2H17.5 M17.5,10  H6.9C3.1,10,0,13.1,0,16.9c0,3.8,3.1,6.9,6.9,6.9h10.6c3.8,0,6.9-3.1,6.9-6.9C24.4,13.1,21.3,10,17.5,10L17.5,10z"></path>
    </svg>
)

export const Adobe = ({ style }) => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 133.5 118.1"
        transform="scale(0.6)"
    >
        <g id="Layer_1-2" data-name="Layer 1">
            <g>
                <polygon
                    className="cls-1"
                    points="84.1 0 133.5 0 133.5 118.1 84.1 0"
                    fill="#fa0f00"
                />
                <polygon
                    className="cls-1"
                    points="49.4 0 0 0 0 118.1 49.4 0"
                    fill="#fa0f00"
                />
                <polygon
                    className="cls-1"
                    points="66.7 43.5 98.2 118.1 77.6 118.1 68.2 94.4 45.2 94.4 66.7 43.5"
                    fill="#fa0f00"
                />
            </g>
        </g>
    </svg>
)

export const AmazonConnectFilled = ({ style }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        width="170px"
        height="143px"
        viewBox="0 0 47 42"
        version="1.1"
        transform="scale(0.8)"
    >
        <g
            id="Connect-Colors-V1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Metrics-Navigation-Copy-26"
                transform="translate(-9.000000, -10.000000)"
            >
                <g id="Header-Copy-6">
                    <g
                        id="Page-1-Copy-3"
                        transform="translate(9.000000, 10.000000)"
                    >
                        <path
                            d="M39.5085902,13.257345 L39.5228232,13.1638025 C39.0806515,6.653621 33.1170263,5.52638639 30.4507118,9.12068687 L30.4507118,9.12163175 C29.7447552,7.13078234 28.6734851,5.29961664 27.2188729,3.84640051 C24.0724321,0.702804901 19.2891967,-0.971511728 14.0552498,1.23571381 C9.97891983,2.95443951 7.12662752,7.77140688 7.12662752,11.9553087 C7.12662752,12.447588 7.15604237,12.9323084 7.21297436,13.40758 L7.21297436,13.4047453 C4.23258508,14.164424 0.875495858,16.4255073 0.875495858,21.5334959 C0.875495858,21.6232589 0.876444725,21.7130219 0.878342457,21.8008952 C0.986513224,26.2635348 4.84175729,29.9457086 9.32420203,29.950433 L18.5661605,29.950433 L18.5661605,41.1991573 L30.7021614,29.950433 L38.4610417,29.950433 C39.4507093,29.9513778 40.4356326,29.7964185 41.3721637,29.477996 C43.6532385,28.7022545 46.9998902,26.6962871 46.9998902,21.6043614 C46.9998902,15.6280337 42.2204503,13.7212781 39.5085902,13.257345 Z"
                            id="Stroke-3"
                            fill="#00ABBA"
                        />
                        <path
                            d="M18.6412158,15.521074 L13.6444855,19.0407294"
                            id="Stroke-11"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M24.4460007,21.6205188 L21.6003505,16.2300129"
                            id="Stroke-13"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M32.399968,18.8097078 L27.4041865,22.3284183"
                            id="Stroke-15"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M34.8235625,15.2443204 C33.5824453,14.94763 32.3337371,15.7091984 32.0357931,16.9450935 C31.737849,18.1819335 32.5026353,19.4244427 33.7447014,19.7211332 C34.9858186,20.0178236 36.2335779,19.2562552 36.531522,18.0203601 C36.829466,16.7835201 36.0646797,15.5410108 34.8235625,15.2443204 Z"
                            id="Stroke-17"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M26.0599276,21.4170874 C24.8188103,21.120397 23.5701022,21.8819654 23.2721582,23.1178605 C22.9742141,24.3547005 23.7390004,25.5972097 24.9810665,25.8939002 C26.2221837,26.1905906 27.469943,25.4290222 27.767887,24.1931271 C28.0658311,22.9562871 27.3010448,21.7137778 26.0599276,21.4170874 Z"
                            id="Stroke-19"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M21.0648103,11.9556867 C19.8236931,11.6589962 18.574985,12.4205646 18.2770409,13.6564598 C17.9790969,14.8932997 18.7438832,16.135809 19.9859492,16.4324994 C21.2270665,16.7291898 22.4748257,15.9676214 22.7727698,14.7317263 C23.0707138,13.4948863 22.3059275,12.2523771 21.0648103,11.9556867 Z"
                            id="Stroke-21"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M12.3010805,18.1284536 C11.0599633,17.8317632 9.81125514,18.5933316 9.5133111,19.8292267 C9.21536706,21.0660667 9.98015336,22.308576 11.2222194,22.6052664 C12.4633367,22.9019568 13.7110959,22.1403884 14.00904,20.9044933 C14.306984,19.6676533 13.5421977,18.4251441 12.3010805,18.1284536 Z"
                            id="Stroke-23"
                            stroke="#26303B"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const UserIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100"
        viewBox="0 0 18 18"
        width="100"
    >
        <defs>
            <style>
                {`.fill {
          fill: #474747;
        }`}
            </style>
        </defs>
        <title>S User 18 N</title>
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
        <path
            className="fill"
            d="M16.4745,17a.4965.4965,0,0,0,.50089-.49207q.00015-.01724-.00089-.03443c-.3305-3.592-4.0135-4.8155-5.139-4.9135C11.013,11.4885,11,10.826,11,10a7.51507,7.51507,0,0,0,1.766-4.479C12.766,2.8085,11.2225,1,9,1S5.234,2.8085,5.234,5.521A7.51507,7.51507,0,0,0,7,10c0,.826-.013,1.4885-.837,1.56-1.1255.1-4.8085,1.3215-5.139,4.9135a.49649.49649,0,0,0,.46557.52561q.01719.001.03443.00089Z"
        />
    </svg>
)

export const ChevronDown = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="18"
        viewBox="0 0 18 18"
        width="18"
    >
        <defs>
            <style>
                {`.fill {
          fill: #474747;
        }`}
            </style>
        </defs>
        {/* <title>S ChevronDown 18 N</title> */}
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
        <path
            class="fill"
            d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z"
        />
    </svg>
)

export const ChevronUp = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="18"
        viewBox="0 0 18 18"
        width="18"
    >
        <defs>
            <style>
                {`.fill {
          fill: #474747;
        }`}
            </style>
        </defs>
        {/* <title>S ChevronUp 18 N</title> */}
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
        <path
            class="fill"
            d="M14,10.99a1,1,0,0,1-1.7055.7055l-3.289-3.286-3.289,3.286a1,1,0,0,1-1.437-1.3865l.0245-.0245L8.3,6.2925a1,1,0,0,1,1.4125,0L13.707,10.284A.9945.9945,0,0,1,14,10.99Z"
        />
    </svg>
)
export const UpArrow = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
    >
        <g id="ArrowSize100" transform="rotate(270 5 5)">
            <rect id="Frame" width="10" height="10" fill="red" opacity="0" />
            <path d="M9.94952,4.99652a.87815.87815,0,0,0-.02966-.15259.854.854,0,0,0-.03522-.17315L9.882,4.66217A.86384.86384,0,0,0,9.7464,4.459a.819.819,0,0,0-.04718-.07226l-.00488-.005-.00086-.00079L6.62354,1.26172A.87459.87459,0,1,0,5.37646,2.48828L6.98682,4.125H.9248a.875.875,0,0,0,0,1.75h6.062L5.37646,7.51172A.87459.87459,0,1,0,6.62354,8.73828l3.06994-3.1192.00086-.00079.00488-.005A.819.819,0,0,0,9.7464,5.541.86384.86384,0,0,0,9.882,5.33783l.00262-.00861a.854.854,0,0,0,.03522-.17315.87815.87815,0,0,0,.02966-.15259L9.9502,5Z" />
        </g>
    </svg>
)
export const DownArrow = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
    >
        <g id="ArrowSize100" transform="rotate(90 5 5)">
            <rect id="Frame" width="10" height="10" fill="red" opacity="0" />
            <path d="M9.94952,4.99652a.87815.87815,0,0,0-.02966-.15259.854.854,0,0,0-.03522-.17315L9.882,4.66217A.86384.86384,0,0,0,9.7464,4.459a.819.819,0,0,0-.04718-.07226l-.00488-.005-.00086-.00079L6.62354,1.26172A.87459.87459,0,1,0,5.37646,2.48828L6.98682,4.125H.9248a.875.875,0,0,0,0,1.75h6.062L5.37646,7.51172A.87459.87459,0,1,0,6.62354,8.73828l3.06994-3.1192.00086-.00079.00488-.005A.819.819,0,0,0,9.7464,5.541.86384.86384,0,0,0,9.882,5.33783l.00262-.00861a.854.854,0,0,0,.03522-.17315.87815.87815,0,0,0,.02966-.15259L9.9502,5Z" />
        </g>
    </svg>
)
export const NotFoundIconSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={99.039}
        height={94.342}
        {...props}
    >
        <g
            fill="none"
            stroke="#b3b3b3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                d="M93.113 88.415a5.38 5.38 0 0 1-7.61 0L58.862 61.773a1.018 1.018 0 0 1 0-1.44l6.17-6.169a1.018 1.018 0 0 1 1.439 0l26.643 26.643a5.38 5.38 0 0 1 0 7.608z"
                strokeWidth={2.99955}
            />
            <path
                strokeWidth={2}
                d="M59.969 59.838l-3.246-3.246M61.381 51.934l3.246 3.246M64.609 61.619l13.327 13.327"
            />
            <path
                d="M13.311 47.447A28.87 28.87 0 1 0 36.589 1.5c-10.318 0-20.141 5.083-24.7 13.46M2.121 38.734l15.536-15.536M17.657 38.734L2.121 23.198"
                strokeWidth={3}
            />
        </g>
    </svg>
)

export const SlackIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="-2.45 0 2452.5 2452.5"
        // enable-background="new 0 0 2447.6 2452.5"
    >
        <g 
        // clip-rule="evenodd" fill-rule="evenodd"
        >
            <path
                d="m897.4 0c-135.3.1-244.8 109.9-244.7 245.2-.1 135.3 109.5 245.1 244.8 245.2h244.8v-245.1c.1-135.3-109.5-245.1-244.9-245.3.1 0 .1 0 0 0m0 654h-652.6c-135.3.1-244.9 109.9-244.8 245.2-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3z"
                fill="#36c5f0"
            />

            <path
                d="m2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3zm-652.7 0v-654c.1-135.2-109.4-245-244.7-245.2-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3z"
                fill="#2eb67d"
            />

            <path
                d="m1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2zm0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3z"
                fill="#ecb22e"
            />

            <path
                d="m0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2v-245.2h-244.8c-135.3.1-244.9 109.9-244.8 245.2zm652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0"
                fill="#e01e5a"
            />
        </g>
    </svg>
)

export const EmailIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="18px"
        height="18px"
        viewBox="0 0 48 48"
    >
        <path
            fill="#103262"
            d="M43.255,23.547l-6.81-3.967v11.594H44v-6.331C44,24.309,43.716,23.816,43.255,23.547z"
        ></path>
        <path fill="#0084d7" d="M13,10h10v9H13V10z"></path>
        <path fill="#33afec" d="M23,10h10v9H23V10z"></path>
        <path fill="#54daff" d="M33,10h10v9H33V10z"></path>
        <path fill="#027ad4" d="M23,19h10v9H23V19z"></path>
        <path fill="#0553a4" d="M23,28h10v9H23V28z"></path>
        <path fill="#25a2e5" d="M33,19h10v9H33V19z"></path>
        <path fill="#0262b8" d="M33,28h10v9H33V28z"></path>
        <polygon
            points="13,37 43,37 43,24.238 28.99,32.238 13,24.238"
            opacity=".019"
        ></polygon>
        <polygon
            points="13,37 43,37 43,24.476 28.99,32.476 13,24.476"
            opacity=".038"
        ></polygon>
        <polygon
            points="13,37 43,37 43,24.714 28.99,32.714 13,24.714"
            opacity=".057"
        ></polygon>
        <polygon
            points="13,37 43,37 43,24.952 28.99,32.952 13,24.952"
            opacity=".076"
        ></polygon>
        <polygon
            points="13,37 43,37 43,25.19 28.99,33.19 13,25.19"
            opacity=".095"
        ></polygon>
        <polygon
            points="13,37 43,37 43,25.429 28.99,33.429 13,25.429"
            opacity=".114"
        ></polygon>
        <polygon
            points="13,37 43,37 43,25.667 28.99,33.667 13,25.667"
            opacity=".133"
        ></polygon>
        <polygon
            points="13,37 43,37 43,25.905 28.99,33.905 13,25.905"
            opacity=".152"
        ></polygon>
        <polygon
            points="13,37 43,37 43,26.143 28.99,34.143 13,26.143"
            opacity=".171"
        ></polygon>
        <polygon
            points="13,37 43,37 43,26.381 28.99,34.381 13,26.381"
            opacity=".191"
        ></polygon>
        <polygon
            points="13,37 43,37 43,26.619 28.99,34.619 13,26.619"
            opacity=".209"
        ></polygon>
        <polygon
            points="13,37 43,37 43,26.857 28.99,34.857 13,26.857"
            opacity=".229"
        ></polygon>
        <polygon
            points="13,37 43,37 43,27.095 28.99,35.095 13,27.095"
            opacity=".248"
        ></polygon>
        <polygon
            points="13,37 43,37 43,27.333 28.99,35.333 13,27.333"
            opacity=".267"
        ></polygon>
        <polygon
            points="13,37 43,37 43,27.571 28.99,35.571 13,27.571"
            opacity=".286"
        ></polygon>
        <polygon
            points="13,37 43,37 43,27.81 28.99,35.81 13,27.81"
            opacity=".305"
        ></polygon>
        <polygon
            points="13,37 43,37 43,28.048 28.99,36.048 13,28.048"
            opacity=".324"
        ></polygon>
        <polygon
            points="13,37 43,37 43,28.286 28.99,36.286 13,28.286"
            opacity=".343"
        ></polygon>
        <polygon
            points="13,37 43,37 43,28.524 28.99,36.524 13,28.524"
            opacity=".362"
        ></polygon>
        <polygon
            points="13,37 43,37 43,28.762 28.99,36.762 13,28.762"
            opacity=".381"
        ></polygon>
        <polygon
            points="13,37 43,37 43,29 28.99,37 13,29"
            opacity=".4"
        ></polygon>
        <linearGradient
            id="Qf7015RosYe_HpjKeG0QTa_ut6gQeo5pNqf_gr1"
            x1="38.925"
            x2="32.286"
            y1="24.557"
            y2="36.024"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stop-color="#31abec"></stop>
            <stop offset="1" stop-color="#1582d5"></stop>
        </linearGradient>
        <path
            fill="url(#Qf7015RosYe_HpjKeG0QTa_ut6gQeo5pNqf_gr1)"
            d="M15.441,42h26.563c1.104,0,1.999-0.889,2-1.994C44.007,35.485,44,24.843,44,24.843	s-0.007,0.222-1.751,1.212S14.744,41.566,14.744,41.566S14.978,42,15.441,42z"
        ></path>
        <linearGradient
            id="Qf7015RosYe_HpjKeG0QTb_ut6gQeo5pNqf_gr2"
            x1="13.665"
            x2="41.285"
            y1="6.992"
            y2="9.074"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".042" stop-color="#076db4"></stop>
            <stop offset=".85" stop-color="#0461af"></stop>
        </linearGradient>
        <path
            fill="url(#Qf7015RosYe_HpjKeG0QTb_ut6gQeo5pNqf_gr2)"
            d="M43,10H13V8c0-1.105,0.895-2,2-2h26c1.105,0,2,0.895,2,2V10z"
        ></path>
        <linearGradient
            id="Qf7015RosYe_HpjKeG0QTc_ut6gQeo5pNqf_gr3"
            x1="28.153"
            x2="23.638"
            y1="33.218"
            y2="41.1"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stop-color="#33acee"></stop>
            <stop offset="1" stop-color="#1b8edf"></stop>
        </linearGradient>
        <path
            fill="url(#Qf7015RosYe_HpjKeG0QTc_ut6gQeo5pNqf_gr3)"
            d="M13,25v15c0,1.105,0.895,2,2,2h15h12.004c0.462,0,0.883-0.162,1.221-0.425L13,25z"
        ></path>
        <path
            d="M21.319,13H13v24h8.319C23.352,37,25,35.352,25,33.319V16.681C25,14.648,23.352,13,21.319,13z"
            opacity=".05"
        ></path>
        <path
            d="M21.213,36H13V13.333h8.213c1.724,0,3.121,1.397,3.121,3.121v16.425	C24.333,34.603,22.936,36,21.213,36z"
            opacity=".07"
        ></path>
        <path
            d="M21.106,35H13V13.667h8.106c1.414,0,2.56,1.146,2.56,2.56V32.44C23.667,33.854,22.52,35,21.106,35z"
            opacity=".09"
        ></path>
        <linearGradient
            id="Qf7015RosYe_HpjKeG0QTd_ut6gQeo5pNqf_gr4"
            x1="3.53"
            x2="22.41"
            y1="14.53"
            y2="33.41"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stop-color="#1784d8"></stop>
            <stop offset="1" stop-color="#0864c5"></stop>
        </linearGradient>
        <path
            fill="url(#Qf7015RosYe_HpjKeG0QTd_ut6gQeo5pNqf_gr4)"
            d="M21,34H5c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C23,33.105,22.105,34,21,34z"
        ></path>
        <path
            fill="#fff"
            d="M13,18.691c-3.111,0-4.985,2.377-4.985,5.309S9.882,29.309,13,29.309	c3.119,0,4.985-2.377,4.985-5.308C17.985,21.068,16.111,18.691,13,18.691z M13,27.517c-1.765,0-2.82-1.574-2.82-3.516	s1.06-3.516,2.82-3.516s2.821,1.575,2.821,3.516S14.764,27.517,13,27.517z"
        ></path>
    </svg>
)
